export const SET_URL_UTILS = "SET_URL_UTILS";

/**
 * 
 * @param {*}
 * @returns 
 * 
 * Sets login popup visibility
 */
export function setUrlUtils() {
  return (dispatch) => {
    dispatch({
      type: SET_URL_UTILS,
      payload: "",
    });
  };
}
